import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip);

const PlayerStatsChart = ({data, options, chartLabel}) => {

    const memoOptions = useMemo(() => {
        // start from incoming options
        const base = options ?? {};
        const basePlugins = base.plugins ?? {};
        return {
          ...base,
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            ...basePlugins,
          }
        };
    }, [options]);

    return (
        <>
            <div className="text-center mb-2">
                <span id='chart-label' className="font-medium text-gray-700 dark:text-gray-300">{chartLabel}</span>
            </div>

            <div className="relative w-full sm:h-50 lg:h-96">
                <Bar data={data} options={memoOptions} />
            </div>
        </>
    );
};

export default PlayerStatsChart;
